__turbopack_context__.v({
  "block": "paid-module-scss-module__q8Ab8a__block",
  "buttonSimple": "paid-module-scss-module__q8Ab8a__buttonSimple",
  "buttonSimple1": "paid-module-scss-module__q8Ab8a__buttonSimple1",
  "buttongroup": "paid-module-scss-module__q8Ab8a__buttongroup",
  "contactUs": "paid-module-scss-module__q8Ab8a__contactUs",
  "goToHomepage": "paid-module-scss-module__q8Ab8a__goToHomepage",
  "logoIcon": "paid-module-scss-module__q8Ab8a__logoIcon",
  "name": "paid-module-scss-module__q8Ab8a__name",
  "name1": "paid-module-scss-module__q8Ab8a__name1",
  "paid": "paid-module-scss-module__q8Ab8a__paid",
  "paid1440px": "paid-module-scss-module__q8Ab8a__paid1440px",
  "text": "paid-module-scss-module__q8Ab8a__text",
});
